import { render, staticRenderFns } from "./Trigger.vue?vue&type=template&id=5c978a2c"
import script from "./Trigger.vue?vue&type=script&lang=js"
export * from "./Trigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c978a2c')) {
      api.createRecord('5c978a2c', component.options)
    } else {
      api.reload('5c978a2c', component.options)
    }
    module.hot.accept("./Trigger.vue?vue&type=template&id=5c978a2c", function () {
      api.rerender('5c978a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/CompanySwitcher/Trigger.vue"
export default component.exports